import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "L'élégance, d'abord",
    text: "Chemise blanche immaculée, gilet noir ajusté, nœud papillon. Notre brigade incarne le raffinement dès le premier regard, pour que vos invités se souviennent de chaque instant.",
  },
  {
    num: "02",
    title: "La discrétion absolue",
    text: "Présents sans jamais s'imposer. Nos équipes anticipent chaque besoin, circulent avec grâce et laissent vos invités profiter pleinement de votre événement.",
  },
  {
    num: "03",
    title: "L'exigence du détail",
    text: "Un verre toujours rempli, une assiette toujours dressée à l'heure, un geste toujours juste. Sous la direction de votre maître d'hôtel, rien n'est laissé au hasard.",
  },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="bg-[#f9f8f6] px-6 py-28 text-[#0a0a0a] lg:px-10 lg:py-40">
    <div className="mx-auto max-w-7xl">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-6 text-[11px] font-semibold uppercase tracking-[0.4em] text-[#aa8c2c]"
      >
        Notre manifeste
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay: 0.1 }}
        className="mb-24 max-w-3xl font-display text-4xl leading-tight tracking-tight sm:text-5xl lg:text-6xl"
      >
        Le service n'est pas un métier, <em className="italic text-[#aa8c2c]">c'est une signature.</em>
      </motion.h2>
      <div className="grid gap-16 md:grid-cols-3 md:gap-10 lg:gap-16">
        {chapters.map((c, i) => (
          <motion.article
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="border-t border-[#0a0a0a]/15 pt-8"
          >
            <span className="font-display text-6xl font-light text-[#aa8c2c]/40">{c.num}</span>
            <h3 className="mt-6 font-display text-2xl tracking-tight">{c.title}</h3>
            <p className="mt-4 text-sm leading-relaxed text-[#0a0a0a]/60">{c.text}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
